import { computed } from 'vue';

import useAuth from '@/composables/useAuth';

export default function useApiWebhookCreateGate() {
  const { hasPermission } = useAuth();

  const canWrite = computed(() => hasPermission('manage:integrations'));

  const createDisabledReason = computed(() =>
    canWrite.value ? undefined : 'Your role cannot create webhooks.',
  );

  return { canWrite, createDisabledReason };
}
